<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="上级分类" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-cascader
              placeholder="请选择"
              :options="treeData"
              changeOnSelect
              @change="treeChange"
              allowClear
              :field-names="{ label: 'name', value: 'id', children: 'list' }"
              v-decorator="[
          'categoryId',
          {rules: [{ required: true, message: '请选择上级分类!' }],initialValue:info.categoryId}
        ]"
            />
          </a-form-item>
          <a-form-item label="分类名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入分类名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入分类名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
var thisInfo = [];
export default {
  props: {
    id: String
  },
  data() {
    return {
      dis: false,
      form: this.$form.createForm(this),
      info: {
        categoryId: ["0"]
      },
      treeData: [],
      isloading: false,
      loadingTip: "加载中..."
    };
  },
  mounted() {
    that = this;
    this.getTree();
  },
  methods: {
    /**取消 */
    cancelClick() {
      that.$emit("callbackMethod");
    },
    treeChange(val) {
      that.info.categoryId = val;
    },
    /**分类树形数据* */
    getTree() {
      that.$api.questioncategory
        .getTree()
        .then(res => {
          if (res.errorCode == that.$msg.responseCode.success) {
            var allData = [
              {
                name: "根目录",
                parentId: "0",
                id: "0",
                list: res.data
              }
            ];
            that.treeData = allData;
            this.$nextTick(function() {
              if (that.id && that.id != "0") {
                //编辑
                that.getInfo();
              }
            });
          } else {
            that.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**获取详情 */
    getInfo() {
      thisInfo = [];
      that.isloading = true;
      that.$api.questioncategory
        .getById(that.id)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            if (res.data.parentId) {
              that.getParentChain(res.data.parentId);
              thisInfo = res.data;
              that.info.id = res.data.id;
              that.info.name = res.data.name;
              that.info.parentId = res.data.parentId;
            } else {
              that.info = res.data;
              that.info.categoryId = ["0"];
            }
          } else {
            that.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**回显栏目 */
    getParentChain(id) {
      var parentids = that.$commen.concatTree(that.treeData, "id", id, "list");
      that.info.categoryId = [];
      for (var i = 0; i < parentids.length; i++) {
        that.info.categoryId.push(parentids[i].id);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      that.form.validateFields((err, values) => {
        if (!err) {
          if (that.id && that.id != "0") {
            //修改
            that.isloading = true;
            that.loadingTip = "保存中...";
            that.$api.questioncategory
              .updateById(
                that.id,
                values.name,
                that.info.categoryId[that.info.categoryId.length - 1]
              )
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  that.$emit("callbackMethod");
                } else {
                  that.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
          } else {
            //添加
            that.isloading = true;
            that.loadingTip = "保存中...";
            that.$api.questioncategory
              .save(
                values.name,
                that.info.categoryId[that.info.categoryId.length - 1]
              )
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.$message.success(res.errorMsg);
                  that.$emit("callbackMethod");
                } else {
                  that.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
          }
        }
      });
    },
    error(msg) {
      that.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
</style>